import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomSkeletonElement } from '../../commons/CustomSkeletonElement';
import { TypedService } from '../../../models/ServicePresets';
// import { turboGigShareId } from '../../../constants/configuration';
import { useDateLocalization } from '../../../hooks/useDateLocalization';
import { IShares } from '../../../models/UserInfo';

interface ServiceInfoProps {
  internetLogin: string | null;
  service?: TypedService;
  userInfoShares: IShares | undefined;
}

const ServiceInfo: FC<ServiceInfoProps> = ({ internetLogin, service, userInfoShares }) => {
  const { t } = useTranslation();
  const { formatDate } = useDateLocalization();

  const activatedShare = useMemo(
    () => userInfoShares?.Activated.find((item) => item.id === service?.Share?.id),
    [userInfoShares?.Activated, service?.Share?.id],
  );

  return (
    <div className="payment__content__options__service-changer__service-name">
      <article className="payment__content__label">
        {t('servicePayment.service')}
        {service?.Share ? (
          <>
            &nbsp;&nbsp;&nbsp;
            <span className="extra-prompt">
              &quot;{service.Share.Name}&quot;{' '}
              {service.Share.StopDate ? t('serviceManagement.nextPaymentDate').toLowerCase() : ''}{' '}
              {service.Share.StopDate
                ? formatDate(activatedShare ? activatedShare.ActiveTo : service.Share.StopDate, {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    locale: 'uk',
                  })
                : ''}
            </span>
          </>
        ) : null}
      </article>
      {!service?.Name ? (
        <CustomSkeletonElement
          skeletonContainerClassName="service-name-skeleton"
          skeletonChildrenClassName="service-name-skeleton__btn skeleton"
          childrenCount={1}
        />
      ) : (
        <div className="payment__content__options__service-changer__service-name__name">
          <strong className="payment__content__options__service-changer__service-name__name__value">
            {service?.Name}
          </strong>
          {(service?.Price ?? null) !== null && (
            <p>
              {service?.Price} {service.Daily ? t('servicePayment.costPerDay') : t('servicePayment.costPerMonth')}
            </p>
          )}
        </div>
      )}
      {typeof internetLogin === 'string' && !internetLogin ? (
        <CustomSkeletonElement
          skeletonContainerClassName="internet-login-skeleton"
          skeletonChildrenClassName="internet-login-skeleton__btn skeleton"
          childrenCount={1}
        />
      ) : (
        internetLogin && <article className="payment__content__label">{internetLogin}</article>
      )}
    </div>
  );
};

export default ServiceInfo;
